<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect class="svg_check_border" x="1" y="1" width="22" height="22" rx="2" stroke="currentColor" fill="none" stroke-width="2"/>
</svg>
